module.exports = __webpack_public_path__ + "static/media/dr-i.9b2fb368.png";